const activateTemplate = (key, options = {}) => {
  const templateElement = document.querySelector(
    `template[data-template-key='${key}']`
  );

  if (!templateElement) {
    if (options.resolveOnMissing) {
      // eslint-disable-next-line no-console
      console.warn(
        "Template not found, resolving because of 'resolveOnMissing option"
      );
      return Promise.resolve({ wasInjected: false });
    }

    return Promise.reject(new Error("Template not found"));
  }

  if (templateElement.hasAttribute("data-has-been-activated")) {
    return Promise.resolve({ wasInjected: false });
  }

  const promise = new Promise(resolve => {
    // Old Safari kludge: dynamically inserted srcsets are not respected, so we have to force a rerender
    // of image after https://stackoverflow.com/questions/45487105/ajax-loaded-images-in-safari-not-respecting-srcset
    const doKludgeForOldSafari =
      navigator.userAgent.includes("Safari") &&
      navigator.userAgent.includes("Version/15");

    const templateClone = templateElement.content.cloneNode(true);
    let images;

    if (doKludgeForOldSafari) {
      images = templateClone.querySelectorAll("img[srcset]");
    }

    templateElement.after(templateClone);

    if (doKludgeForOldSafari) {
      images.forEach(image => {
        image.outerHTML = image.outerHTML;
      });
    }

    templateElement.setAttribute("data-has-been-activated", true);
    resolve({ wasInjected: true });
  });

  return promise;
};

export { activateTemplate };
